import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ModeService } from '../service/mode.service';
import { PlanModulesService } from '../service/plan-modules.service';
import { resolveModuleKeyFromPath } from '../constants/business-modules.catalog';

@Injectable({ providedIn: 'root' })
export class BusinessModuleGuard implements CanActivate {
  constructor(
    private modeService: ModeService,
    private planModules: PlanModulesService,
    private router: Router,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.planModules.isBypassRole()) return true;
    if (this.modeService.activeMode !== 'business') return true;

    const moduleKey = resolveModuleKeyFromPath(state.url);
    if (!moduleKey) return true;

    if (this.planModules.hasModule(moduleKey)) return true;

    this.router.navigate(['/inicio'], { queryParams: { moduleDenied: moduleKey } });
    return false;
  }
}
